<template>
  <el-dialog
    title="发起退车"
    :visible.sync="dialogVisible"
    width="40%"
  >
    <p class="terminal-title" v-html="content"></p>
    <el-radio-group v-model="extendReturn" v-if="extendState === EXTEND_STATE.WITHHOLD_WITH_DELAY">
      <el-radio :label="1">延长网约钱包支付，{{extendDay}}天后解约</el-radio>
      <br />
      <el-radio :label="2">不延长网约钱包支付，立即解约</el-radio>
    </el-radio-group>
    <span slot="footer">
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="confirmTerminate"
      >确认退车</el-button>
    </span>
  </el-dialog>
</template>
<script setup>
import { preTerminate } from '@/api/withhold'
import { reactive, ref } from 'vue'

const props = defineProps({
  // 订单ID数据
  orderId: Number,
  // 回调函数
  callback: Function,
})

// 弹窗状态
const EXTEND_STATE = reactive({
  // 未开通代扣
  NO_WITHHOLD: 0,
  // 开通代扣，但没有配置延期代扣，或延期支付配置为0
  WITHHOLD_NO_DELAY: 1,
  // 开通代扣，且配置了>0的延期天数
  WITHHOLD_WITH_DELAY: 2,
})
// 延期弹窗
const dialogVisible = ref(false)
// 弹窗状态
const extendState = ref(EXTEND_STATE.NO_WITHHOLD)
// 延期天数
const extendDay = ref(0)
// 延期日期
const extendDate = ref('')
// 弹窗文案
const content = ref('')
// 是否延期代扣
const extendReturn = ref(1)
// 确认退车按钮防重复提交
const submitLoading = ref(false)

// 无延期代扣文案
const withholdNoDelayTpl = (alipayWithhold, onlineWalletWithhold) => {
  let text = ''
  if (alipayWithhold === 1 && onlineWalletWithhold === 1) {
    text = '网约钱包支付和支付宝支付'
  } else if (onlineWalletWithhold === 1) {
    text = '网约钱包支付'
  } else if (alipayWithhold === 1) {
    text = '支付宝支付'
  }
  return `退车解约后，${text}将同时解约，但是已支付成功未完成结算（收款单状态为收款中）的数据不受影响，确认退车解约吗？`
}

// 有延期代扣文案
const withholdWithDelayTpl = (day, date) => {
  return `退车后，网约钱包支付可延长至 <span style="color: red">${date}</span>（${day}天后），确认退车解约吗？`
}

// 前置检查，获取延期支付配置，外部调用
const preCheck = () => {
  submitLoading.value = false
  return preTerminate(props.orderId).then((res) => {
    const { code, data } = res || {}
    if (code === 1) {
      const {
        popStatus, // 弹窗状态
        walletPersonalStatus, // 支付宝个人钱包的签约状态
        walletOnlineStatus, // 网约钱包的签约状态
        extendDay: extendDayParams, // 延长天数，几天后
        extendDate: extendDateParam, // 延长日期
      } = data || {}
      extendState.value = popStatus
      // 根据extendState有3种逻辑 https://cheweijia.yuque.com/pixhfh/inhvt9/zdzlgk7e3imqxo7s
      if (extendState.value === EXTEND_STATE.NO_WITHHOLD) {
        // 1：没有开通代扣：不弹窗，直接发起退车
        return props.callback()
      }
      if (extendState.value === EXTEND_STATE.WITHHOLD_NO_DELAY) {
        // 2：开通代扣，但没有配置延期代扣或延期支付配置为0：仅弹出代扣解约弹窗，用户确认后发起退车
        content.value = withholdNoDelayTpl(walletPersonalStatus, walletOnlineStatus)
      } else if (extendState.value === EXTEND_STATE.WITHHOLD_WITH_DELAY) {
        // 3：开通代扣，且配置了>0的延期天数：弹出让用户选择是否延期代扣弹窗，用户选择后发起退车
        extendDay.value = extendDayParams
        extendDate.value = extendDateParam
        content.value = withholdWithDelayTpl(extendDayParams, extendDateParam)
      }
      dialogVisible.value = true
    }
  })
}

// 确认延期配置
const confirmTerminate = () => {
  if (submitLoading.value) return
  submitLoading.value = true
  dialogVisible.value = false
  if (extendState.value === EXTEND_STATE.WITHHOLD_NO_DELAY) {
    props.callback()
    return
  }
  props.callback(undefined, { extendReturn: extendReturn.value })
}

// 对外暴露的方法
defineExpose({
  preCheck,
})
</script>
<script>
export default {
  name: 'TerminateWithhold',
}
</script>
<style lang="scss" scoped>
.terminal-title {
  margin-bottom: 16px;
}
</style>
